module.exports = __webpack_public_path__ + "static/media/intro.dc83247a.mp3";